import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ArchivedLeadCardState {
  isSelectionMode: boolean;
  selectedLeadIds: (string | number)[];
  isDeleteConfirmationModalOpen: boolean;
  isRestoreConfirmationModalOpen: boolean;
  searchTerm: string;
  currentPage: number;
}

const initialState: ArchivedLeadCardState = {
  isSelectionMode: false,
  selectedLeadIds: [],
  isDeleteConfirmationModalOpen: false,
  isRestoreConfirmationModalOpen: false,
  searchTerm: "",
  currentPage: 1,
};

const archievedLeadCardSlice = createSlice({
  name: "archievedLeadCard",
  initialState,
  reducers: {
    setIsSelectionMode: (state, action: PayloadAction<boolean>) => {
      state.isSelectionMode = action.payload;
    },
    setSelectedLeadIds: (state, action: PayloadAction<(string | number)[]>) => {
      state.selectedLeadIds = action.payload;
    },
    toggleLeadSelection: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;
      if (state.selectedLeadIds.includes(id)) {
        state.selectedLeadIds = state.selectedLeadIds.filter(
          (item) => item !== id
        );
      } else {
        state.selectedLeadIds.push(id);
      }
    },
    clearSelectedLeadIds: (state) => {
      state.selectedLeadIds = [];
    },
    selectAllLeads: (state, action: PayloadAction<(string | number)[]>) => {
      state.selectedLeadIds = action.payload;
    },
    setIsDeleteConfirmationModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isDeleteConfirmationModalOpen = action.payload;
    },
    setIsRestoreConfirmationModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isRestoreConfirmationModalOpen = action.payload;
    },
    setArchivedSearchTerm: (state, action: PayloadAction<string>) => {
      // Changing the search narrows the archived set, so any prior selection
      // (especially a full "Select All" resolved against the OLD search) must
      // be dropped — otherwise Restore/Delete would act on leads that are no
      // longer visible. Also exit selection mode for a clean slate.
      if (action.payload !== state.searchTerm) {
        state.selectedLeadIds = [];
        state.isSelectionMode = false;
      }
      state.searchTerm = action.payload;
      state.currentPage = 1;
    },
    setArchivedCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetArchivedPanel: (state) => {
      state.isSelectionMode = false;
      state.selectedLeadIds = [];
      state.isDeleteConfirmationModalOpen = false;
      state.isRestoreConfirmationModalOpen = false;
      state.searchTerm = "";
      state.currentPage = 1;
    },
  },
});

export const {
  setIsSelectionMode,
  setSelectedLeadIds,
  toggleLeadSelection,
  clearSelectedLeadIds,
  selectAllLeads,
  setIsDeleteConfirmationModalOpen,
  setIsRestoreConfirmationModalOpen,
  setArchivedSearchTerm,
  setArchivedCurrentPage,
  resetArchivedPanel,
} = archievedLeadCardSlice.actions;
export default archievedLeadCardSlice.reducer;
